import { TProduct } from '../../types/analytics';
import { IApplicationState } from '../../types/redux';

export const getProduct =
  (id: number) =>
  (state: IApplicationState): TProduct => {
    return state.analytics.productsById[id];
  };
